module.exports = __webpack_public_path__ + "static/media/bookings.e747b627.svg";